监测点列
<template>
    <div class="uk-flex">
        <div>
            <i v-icon="['carrierTypeConvert', row.typeId]"></i>
            <i v-icon:theme="['isAbnormalConvert', row.abnormal]"></i>
            <!-- <template v-if="row.alarm_switch">
                <i :class="isAlarmConvert(row.alarm_switch).icon" class="color-theme icon-margin cursor-pointer" :title="row.alarmTriggerList.map(item => item.name).join(',')"></i>
            </template>
            <template v-else>
                <i v-icon:theme="['isAlarmConvert', row.alarm_switch]" style="margin-right:5px;"></i>
            </template> -->
            <i v-icon="['carrierStatusConvert', row.status]"></i>
        </div>

        <div class="ellipsis" style="width:200px">{{ row[index] }}</div>
    </div>
</template>

<script>
import Tooltip from '@/pages/system/resource/components/tooltip.vue';
export default {
    props: ['row', 'index'],
    components: {
        Tooltip
    },
    data() {
        return {};
    }
};
</script>
